import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Activity,
  Banknote,
  Building2,
  Globe,
  LayoutDashboard,
  MapPinned,
  MessageSquareWarning,
  ScrollText,
  Settings,
  ShieldCheck,
  UserCheck,
  Users,
} from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { visibleAdminNavItems } from '../../../constants/adminNav';

const ICONS = {
  LayoutDashboard,
  MessageSquareWarning,
  ShieldCheck,
  UserCheck,
  Settings,
  Users,
  Building2,
  Activity,
  Banknote,
  Globe,
  MapPinned,
  ScrollText,
};

export default function AdminSidebar({ role, onNavigate }) {
  const { t } = useLanguage();
  const items = visibleAdminNavItems(role);

  return (
    <nav className="flex flex-col gap-1 p-3">
      <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">
        {t('admin.shell.brand')}
      </p>
      {items.map((item) => {
        const Icon = ICONS[item.icon] || LayoutDashboard;
        return (
          <NavLink
            key={item.id}
            to={item.path}
            end={item.path === '/admin'}
            onClick={onNavigate}
            className={({ isActive }) =>
              `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium ${
                isActive
                  ? 'bg-indigo-600 text-white'
                  : 'text-slate-700 hover:bg-slate-100'
              }`
            }
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span>{t(item.labelKey)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
